import React from 'react';
import styled from 'styled-components';
import ScrollAnimation from 'react-animate-on-scroll';

const Container = styled.div`
  & > div {
    & > p:nth-child(1) {
      margin-left: 5px;
      margin-top: 20px;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0.05em;
      line-height: 140%;
      text-align: center;
      white-space: pre-line;
    }
    & > p:nth-child(2) {
      margin-left: 5px;
      margin-top: 30px;
      font-size: 17px;
      font-weight: 200;
      letter-spacing: 0.05em;
      line-height: 180%;
      text-align: center;
      white-space: pre-line;
    }
  }
`

const SubTitle = ({ style, title, text }) => {
  return (
    <Container style={style}>
      <ScrollAnimation animateIn='fadeIn' duration="2">
        <p>{title}</p>
        <p>{text}</p>
      </ScrollAnimation>
    </Container>
  )
}

export default SubTitle;